import React, { useMemo } from 'react';
import classNames from 'classnames';
import uuidv4 from '../../utils/uuidv4';
/**
 * Bronson Select component.
 *
 * @see https://bronson.vwfs.io/default/components/detail/bronson-select.html
 *
 * @constructor
 */
export function Select({ error, disabled, name, id, testId, children, className, success, ...otherProps }) {
    /**
     * Generate unique id, if prop `id` is not provided to improve accessibility.
     */
    const selectId = useMemo(() => id ?? uuidv4('select-'), [id]);
    const divClassNameList = classNames('c-input c-input--select', className).trim();
    const selectClassNameList = classNames('c-input__input', {
        'is-success': success,
    }).trim();
    return (React.createElement("div", { className: divClassNameList },
        React.createElement("select", { id: selectId, className: selectClassNameList, name: name, disabled: disabled, "aria-invalid": error ? true : undefined, "data-testid": testId, ...otherProps }, children)));
}
Select.displayName = 'Select';
/**
 * Bronson SelectItem component (nested).
 *
 * @constructor
 */
function SelectItem({ children, value, ...otherProps }) {
    return (React.createElement("option", { ...otherProps, value: value }, children));
}
SelectItem.displayName = 'Select.Item';
Select.Item = SelectItem;
